import Header from "../../components/feature/Header";
import Card from "../../components/base/Card";
import Button from "../../components/base/Button";

interface Props {
    onStart: () => void;
}

export default function WelcomeScreen({ onStart }: Props) {
    return (
        <div className="min-h-screen bg-gradient-to-br from-purple-50 to-indigo-100">
            {/* <Header showAuth={false} /> */}
            <div className="max-w-2xl mx-auto px-4 py-12">
                <Card className="text-center p-8">
                    <div className="w-20 h-20 bg-purple-100 text-purple-600 rounded-full flex items-center justify-center mx-auto mb-6">
                        <i className="ri-robot-line text-3xl"></i>
                    </div>
                    <h1 className="text-3xl font-bold text-gray-900 mb-4">
                        Ready for Your AI Interview?
                    </h1>
                    <p className="text-lg text-gray-600 mb-8">
                        You're about to begin a voice-based interview simulation.
                    </p>

                    <Button onClick={onStart} size="lg" className="px-12">
                        <i className="ri-mic-line mr-2"></i>
                        Start Interview
                    </Button>
                </Card>
            </div>
        </div>
    );
}
